var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPressure = function SvgPressure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pressure_svg2__a",
    x1: 65.36,
    x2: 192.36,
    y1: 213.95,
    y2: 88.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__b",
    x1: 46.03,
    x2: 173.03,
    y1: 194.3,
    y2: 69.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__c",
    x1: 80.55,
    x2: 207.55,
    y1: 229.38,
    y2: 104.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__d",
    x1: 31.55,
    x2: 158.55,
    y1: 179.59,
    y2: 54.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__e",
    x1: -3,
    x2: 124,
    y1: 144.49,
    y2: 19.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__f",
    x1: 10.1,
    x2: 137.1,
    y1: 157.8,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__g",
    x1: 3.34,
    x2: 130.34,
    y1: 150.93,
    y2: 25.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__h",
    x1: 5.54,
    x2: 132.54,
    y1: 153.17,
    y2: 28.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__i",
    x1: -11.25,
    x2: 115.75,
    y1: 136.11,
    y2: 11.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__j",
    x1: -17.79,
    x2: 109.21,
    y1: 129.46,
    y2: 4.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__k",
    x1: -10.99,
    x2: 116.01,
    y1: 136.37,
    y2: 11.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__l",
    x1: 5.15,
    x2: 132.15,
    y1: 152.77,
    y2: 27.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__m",
    x1: 20.93,
    x2: 147.93,
    y1: 168.8,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#pressure_svg2__a",
    id: "pressure_svg2__n",
    x1: 4.79,
    x2: 131.79,
    y1: 152.4,
    y2: 27.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.91 180.46H92.25c-18.03 0-32.71-14.67-32.71-32.7s14.67-32.71 32.71-32.71c3.35 0 6.62.5 9.77 1.49 7.61-12.87 21.26-20.73 36.41-20.73 22.14 0 40.37 17.09 42.18 38.78 10.98 1.77 19.39 11.32 19.39 22.79 0 12.73-10.35 23.08-23.08 23.08m-84.66-57.72c-13.79 0-25.02 11.22-25.02 25.02s11.22 25.01 25.02 25.01h84.66c8.49 0 15.39-6.9 15.39-15.39s-6.9-15.4-15.39-15.4c-2.12 0-3.85-1.72-3.85-3.85 0-19.1-15.54-34.63-34.63-34.63-13.36 0-25.3 7.47-31.16 19.49-.9 1.86-3.12 2.66-5 1.84a24.8 24.8 0 0 0-10.02-2.09m88.5 15.39h.04z",
    style: {
      fill: "url(#pressure_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.46 141.98c-1.58 0-3.07-.98-3.63-2.57a25.16 25.16 0 0 0-13.56-14.58 3.855 3.855 0 0 1-1.98-5.07c.85-1.95 3.13-2.82 5.07-1.98 8.26 3.62 14.72 10.57 17.72 19.07.71 2-.34 4.2-2.35 4.9-.42.15-.85.22-1.28.22",
    style: {
      fill: "url(#pressure_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.48 145.05c-1.26 0-2.5-.62-3.23-1.76a3.846 3.846 0 0 1 1.15-5.32c3.73-2.41 8.06-3.69 12.52-3.69 2.12 0 3.85 1.72 3.85 3.85s-1.72 3.85-3.85 3.85c-2.97 0-5.86.85-8.35 2.46-.65.42-1.37.62-2.08.62",
    style: {
      fill: "url(#pressure_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.29 103.72a3.84 3.84 0 0 1-3.8-4.47c.56-3.36.84-6.78.84-10.19 0-8.9-1.85-17.49-5.5-25.53a3.844 3.844 0 0 1 1.91-5.09c1.93-.89 4.22-.03 5.09 1.91 4.11 9.04 6.19 18.71 6.19 28.72 0 3.83-.32 7.67-.94 11.44a3.856 3.856 0 0 1-3.79 3.22",
    style: {
      fill: "url(#pressure_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2 158.35c-.1 0-.21 0-.31-.01C28.06 155.47 0 125.04 0 89.06c0-38.33 31.18-69.52 69.51-69.52 15.71 0 30.53 5.11 42.86 14.78a3.84 3.84 0 0 1 .65 5.4 3.85 3.85 0 0 1-5.4.65c-10.97-8.6-24.14-13.14-38.12-13.14-34.08 0-61.82 27.73-61.82 61.82 0 32 24.95 59.07 56.81 61.62 2.12.17 3.7 2.02 3.53 4.14a3.845 3.845 0 0 1-3.83 3.54",
    style: {
      fill: "url(#pressure_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15 54.32a5.83 5.83 0 1 1 0-11.66c3.21 0 5.83 2.62 5.83 5.83s-2.62 5.83-5.83 5.83m0-7.81c-1.1 0-1.99.89-1.99 1.99s.89 1.98 1.99 1.98 1.98-.89 1.98-1.98-.89-1.99-1.98-1.99",
    style: {
      fill: "url(#pressure_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 142.71c-.12 0-.24 0-.37-.02-27.82-2.62-48.8-25.68-48.8-53.64 0-29.71 24.17-53.88 53.88-53.88s53.88 24.17 53.88 53.88c0 6.48-1.15 12.85-3.42 18.9-.75 1.99-2.96 2.98-4.95 2.25-1.99-.75-3-2.97-2.25-4.95a45.8 45.8 0 0 0 2.93-16.2c0-25.47-20.72-46.19-46.18-46.19S23.33 63.58 23.33 89.05c0 23.58 18.37 43.78 41.83 45.98 2.12.2 3.67 2.08 3.47 4.19a3.85 3.85 0 0 1-3.83 3.48",
    style: {
      fill: "url(#pressure_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51 105.49c-4.02 0-7.7-2.03-9.85-5.43a11.59 11.59 0 0 1-.68-11.22l7.05-14.87c.63-1.34 1.99-2.2 3.47-2.2s2.84.86 3.47 2.2l7.05 14.87c1.73 3.63 1.47 7.83-.68 11.22-2.15 3.4-5.83 5.43-9.85 5.43m.02-20.9-3.58 7.55c-.59 1.25-.51 2.64.23 3.82 1.48 2.34 5.22 2.34 6.7 0 .74-1.17.82-2.57.23-3.82z",
    style: {
      fill: "url(#pressure_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51 62.42c-2.12 0-3.85-1.72-3.85-3.85v-3.91c0-2.12 1.72-3.85 3.85-3.85s3.85 1.72 3.85 3.85v3.91c0 2.13-1.72 3.85-3.85 3.85",
    style: {
      fill: "url(#pressure_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.95 71.34c-.98 0-1.97-.38-2.72-1.13l-2.77-2.77a3.85 3.85 0 0 1 0-5.44 3.85 3.85 0 0 1 5.44 0l2.77 2.77a3.85 3.85 0 0 1-2.72 6.57",
    style: {
      fill: "url(#pressure_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.02 92.9h-3.91c-2.12 0-3.85-1.72-3.85-3.85s1.72-3.85 3.85-3.85h3.91c2.12 0 3.85 1.72 3.85 3.85s-1.72 3.85-3.85 3.85",
    style: {
      fill: "url(#pressure_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.19 117.22a3.849 3.849 0 0 1-2.72-6.57l2.77-2.77a3.85 3.85 0 0 1 5.44 0 3.85 3.85 0 0 1 0 5.44l-2.77 2.77c-.75.75-1.73 1.13-2.72 1.13",
    style: {
      fill: "url(#pressure_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91 92.9H100c-2.12 0-3.85-1.72-3.85-3.85s1.72-3.85 3.85-3.85h3.91c2.12 0 3.85 1.72 3.85 3.85s-1.72 3.85-3.85 3.85",
    style: {
      fill: "url(#pressure_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.07 71.34a3.849 3.849 0 0 1-2.72-6.57L91.12 62a3.85 3.85 0 0 1 5.44 0 3.85 3.85 0 0 1 0 5.44l-2.77 2.77c-.75.75-1.73 1.13-2.72 1.13",
    style: {
      fill: "url(#pressure_svg2__n)"
    }
  }));
};
export default SvgPressure;